import { ManualMerchantPage } from "./../manual-merchant/manual-merchant";
import { MerchantYourShopPage } from "./../merchant-your-shop/merchant-your-shop";
import { SelectLanguagePage } from "./../select-language/select-language";
import { MerchantResultPage } from "./../merchant-result/merchant-result";
import { ShopperRequrementPage } from "./../shopper-requrement/shopper-requrement";
import { Storage } from "@ionic/storage";
import { MerchantRentalPage } from "./../merchant-rental/merchant-rental";
import { MerchantMissionPage } from "./../merchant-mission/merchant-mission";
import { MerchantOverviewPage } from "./../merchant-overview/merchant-overview";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";
import { DiscountListPage } from "../discount-list/discount-list";
import { LoginPage } from "../login/login";

@IonicPage()
@Component({
  selector: "page-merchant-home",
  templateUrl: "merchant-home.html",
})
export class MerchantHomePage {
  merchant_no: any;
  step: any;
  round = 0;
  plaza = "";
  title = "HOME PAGE";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("info").then((info) => {
      this.merchant_no = info.team.merchant_id;

      if (info.team.plaza_id == 1) {
        this.plaza = "A";
      } else if (info.team.plaza_id == 2) {
        this.plaza = "B";
      } else if (info.team.plaza_id == 3) {
        this.plaza = "C";
      } else if (info.team.plaza_id == 4) {
        this.plaza = "D";
      } else if (info.team.plaza_id == 5) {
        this.plaza = "E";
      } else if (info.team.plaza_id == 6) {
        this.plaza = "F";
      }
    });

    // setInterval(() => {
    this.storage.get("token").then((token) => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            if (
              response.status == 403 &&
              response.message == "You are not allowed to perform this action."
            ) {
              if (this.storage.clear()) {
                this.navCtrl.setRoot(LoginPage);
              }
            }

            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    // }, 3000);
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLCheckStep;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.step = data.step;
            this.round = data.round;

            if (this.round > 1) {
              this.title = "Round " + this.round;
            }

            this.storage.get("currentStep").then((oldStep) => {
              if (!oldStep) {
                this.storage.set("currentStep", data.step);
              } else if (oldStep != data.step) {
                this.storage.set("currentStep", data.step);
                if (data.step == 1 && data.round == 1) {
                  this.storage.remove("stepGame");
                  this.storage.remove("roundGame");
                  this.storage.remove("language");
                  this.storage.remove("quizRound");
                  this.navCtrl.setRoot(SelectLanguagePage);
                }
              }
            });

            this.storage.get("roundGame").then((oldRound) => {
              if (!oldRound) {
                this.storage.set("roundGame", data.round);
              } else if (oldRound != data.round) {
                this.storage.set("roundGame", data.round);
              }
            });

            refresher.complete();
          },
          (error) => {
            var response = JSON.parse(error._body);
            refresher.complete();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  overviewPage() {
    this.navCtrl.push(MerchantOverviewPage);
  }

  missionPage() {
    this.navCtrl.push(MerchantMissionPage);
  }

  shopperReqPage() {
    this.navCtrl.push(ShopperRequrementPage, {});
  }

  rental() {
    this.navCtrl.push(MerchantRentalPage);
  }

  result() {
    this.navCtrl.push(MerchantResultPage);
  }

  yourShop() {
    this.navCtrl.push(MerchantYourShopPage);
  }

  manual() {
    this.navCtrl.push(ManualMerchantPage);
  }

  gotoDiscount() {
    this.navCtrl.push(DiscountListPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-home/merchant-home.ts